export enum LicenseStepType {
  document = 0,
  exam = 1,
  inspection = 2,
  supplementalLicense = 3,
  education = 4,
  backgroundCheck = 5,
  experience = 6,
  payment = 7,
  other = 8
}